/* istanbul ignore file */

import axios from 'axios';
import { getApiBaseUrl } from 'helpers/api';
import {
  CI_MAX_FILES,
  DEFAULT_CI_FILES,
  MAINTENANCE_KEY,
} from 'store/global/constants';

export interface AppConfigResult {
  data: { success: boolean; data: AppConfigData[] };
  status: number;
}

export interface AppConfigData {
  key: string;
  value: string;
}

export const fetchMaintenanceFlag = async () => {
  try {
    const response = await axios.get(`${getApiBaseUrl()}/params/appConfig`);
    if (response.status === 200 && response.data.success) {
      const appConfig = response.data?.data ?? [];
      const ciMaxFiles =
        appConfig?.find((i: any) => i.key === CI_MAX_FILES)?.value ??
        DEFAULT_CI_FILES;
      localStorage.setItem(CI_MAX_FILES, ciMaxFiles);
      const maintenanceFlag = appConfig?.find(
        (i: any) => i.key === MAINTENANCE_KEY,
      )?.value;
      return maintenanceFlag === 'true' ? true : false;
    } else {
      throw new Error('Failed to fetch maintenance flag');
    }
  } catch (e) {
    throw new Error('Failed to fetch maintenance flag');
  }
};
